import React, { useEffect, useContext } from 'react';
import { GitBranch } from 'react-feather';
import { FundContext } from '../FundPage';
import { PageContentBodyGrid } from '../../../Shared/Page/Page';
import useWindowDimensions from '../../../../Utils/Utils';
import PageGridItem from '../../../Shared/Page/PageGridItem';
import DetailField from '../../../Shared/DetailSection/DetailField';
import DetailSectionHeader from '../../../Shared/DetailSection/DetailSectionHeader';
import DynamicDetails from '../DynamicDetails';
import "../FundPage.scss"


const FundGeneral = ({ portfolio, name }) => {
    const { fund, setFund, editMode, setSelectedTab, staticData, setStaticData, originalStaticData, config, hierarchy } = useContext(FundContext)
    //FIXME - fund is wrong DTO, fix on backend.
    fund.number = fund.fundNumber;
    fund.name = fund.fundName;

    const { width } = useWindowDimensions()
    const fundLabel = portfolio ? "Portfolio" : "Fund"
    const offerLabel = portfolio ? "Product" : "Offer"

    console.log("Fund general has fund", fund)

    console.log("Fund general has hierarchy", hierarchy)

    useEffect(() => {
        setSelectedTab("General")
    }, [])


    function updateFund(newValue, property) {
        // save temporary updates
        const newObj = { ...fund, [property]: newValue }
        setFund(newObj)
    }

    function updateStaticData(key, value) {
        // save temporary updates
        let updatedArr = []
        if (staticData.find(e => e.key === key)) {
            updatedArr = staticData.map(e => {
                if (e.key === key) {
                    return { ...e, value: value }
                } else return e
            })
        } else {
            updatedArr = [...staticData, { key, value }]
        }
        setStaticData(updatedArr)
    }

    function formatFundValue(value) {
        const numberValue = parseFloat(value);
        const formattedValue = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(numberValue);
        return formattedValue;
    }

    const getGroup = (level) => {
        const availableGroups = level.groups;
        const group = availableGroups.find(g => g.funds.includes(fund.id));
        if (!group) return null;
        return group.groupName;
    };

    return (
        <>
            <PageGridItem container col="1 / span 6" direction='col' gap="xl" style={{ display: 'flex' }}>
                <DynamicDetails
                    editMode={editMode}
                    portfolio={fund}
                    staticData={staticData}
                    config={config}
                    group={config && config.find(g => g.groupName === "General")}
                    updateStaticData={updateStaticData}
                    name={name}
                    threeSkyeStyle
                    isClone={fund.cloneOf}
                />
            </PageGridItem>
            <PageGridItem container col="7 / span 6">
                <PageContentBodyGrid rowGap="xl" gridColCount="6" subGrid divider={width < 1200 ? null : 'left'} paddingTop={width < 1200 ? "1.5rem" : null}>
                    <PageGridItem container col="1 / span 6">
                        <DetailSectionHeader header="Hierarchy" icon={<GitBranch />} />
                    </PageGridItem>
                    {fund && fund.cloneOf && (
                        <PageGridItem col="1 / span 3">

                        <DetailField
                            bold
                            editMode={false}
                            onChange={(e) => null}
                            label="Badged version of"
                            value={fund?.name}
                            link={`/admin/portfolio-management/portfolios/${fund.number.substring(0, fund.number.indexOf("_"))}`}
                        />
                    </PageGridItem>
)}
                    <PageGridItem col="1 / span 3">
                        <DetailField
                            bold
                            editMode={false}
                            onChange={(e) => null}
                            label="Platform"
                            value={fund?.schemeName}
                        />
                    </PageGridItem>
                    <PageGridItem col="4 / span 3">
                        <DetailField
                            bold
                            editMode={false}
                            onChange={(e) => null}
                            label="Product"
                            value={fund?.offerName}
                        />
                    </PageGridItem>
                    {hierarchy && hierarchy.length > 0 && hierarchy.map((level, index) => (
                        <PageGridItem col="1 / span 3" key={level.groupingId}>
                            <HierarchyElement level={level} fund={fund} editMode={editMode} />
                           
                           
                        </PageGridItem>
                    ))}
                </PageContentBodyGrid>
            </PageGridItem>
            {/* <PageGridItem container col="7 / span 6">
                <PageContentBodyGrid rowGap="xl" gridColCount="6" subGrid divider={width < 1200 ? null : 'left'} paddingTop={width < 1200 ? "1.5rem" : null}>
                    <PageGridItem container col="1 / span 6">
                        <DetailSectionHeader header="Fees" icon={<CreditCard />} />
                    </PageGridItem>
                    <PageGridItem col="1 / span 3">
                        <DetailField
                            bold
                            editMode={false}
                            onChange={(e) => null}
                            label="Performance fees"
                            value={fund?.performanceFeesApply ? "Yes" : "No"}
                        />
                    </PageGridItem>
                    <PageGridItem col="4 / span 3">
                        <DetailField
                            bold
                            editMode={false}
                            onChange={(e) => null}
                            label="Individual Action Charges"
                            value={fund?.individualChargesApply ? "Yes" : "No"}
                        />
                    </PageGridItem>
                    <PageGridItem col="1 / span 3">
                        <DetailField
                            editMode={false}
                            onChange={(e) => null}
                            label={`Total annual ${fundLabel.toLocaleLowerCase()} charge (%)`}
                            value={fund?.totalAnnualCharge + "%"}
                        />
                    </PageGridItem>
                </PageContentBodyGrid>
            </PageGridItem> */}
        </>
    );
}

export default FundGeneral;


const HierarchyElement = ({ level, fund, editMode }) => {

    const getGroup = (level) => {
        const availableGroups = level.groups;
        const group = availableGroups.find(g => g.funds.includes(fund.id));
        if (!group) return null;
        return group.groupName;
    };

    const multipleGroups = (fund.cloneOf || fund.clones.length > 0) && level.groupingName === 'Practice';   //do not like hardcoding this! But not sure of a better way right now.

    if (!multipleGroups) {

        return  <DetailField
        dropDown={true}
        dropDownOptions={level.groups.map(o => { return { name: o.groupName }; })}
        editMode={editMode}
        label={level.groupingName}
        helperText={"Change the membership of this " + level.groupingName.toLowerCase() + ".  (Change not implemented yet)"}
        helperTextClass="helper-text pt-xs font-size-body-s"
        value={getGroup(level)}
        onChange={(e) => null}
        disabled={false}
        placeholder="Select a group"
    />

    }

    //find master group.  If we are cloneOf, then it's that.  If we have clones, then we are the master.
    const master = fund.cloneOf ? level.groups.find(g => g.funds.includes(fund.cloneOf)) : level.groups.find(g => g.funds.includes(fund.id));
    console.log("Found master", master);
    //find other groups by filtering out master and matching on fund.clones array
    const others = [];
    if (fund.cloneOf) {
        //we are a clone, so others are our sibling clones
        const myself = level.groups.find(g => g.funds.includes(fund.id));
        others.push(myself); 
        fund.clones.forEach(cloneId => {
            const group = level.groups.find(g => g.funds.includes(cloneId));
            console.log("Checking cloneId", cloneId, group);
            if (group && group?.groupName !== master?.groupName) {
                others.push(group);
            }
        });
    } else {
        //we are master, so others are our clones
        fund.clones.forEach(cloneId => {
            const group = level.groups.find(g => g.funds.includes(cloneId));
            console.log("Checking cloneId", cloneId, group);
            if (group && group?.groupName !== master?.groupName) {
                others.push(group);
            }
        });
    }
    console.log("Found others", others);
    //multiple groups, ie it's badged.
    return (
        <React.Fragment>
            <label className="colour-text-label-grey transition-fade-up" >{level.groupingName}</label>
            <div className={`mt-s transition-fade-up-slow`} style={{ wordBreak: "break-word" }}>
            {master && (
                <div className="mt-xs font-size-body-s colour-text-grey font-weight-semi-bold">
                    {master.groupName} <i className='material-symbols-outlined' style={{ verticalAlign: 'middle', color: '#FF9D19' }}>license</i>
                </div>
            )}
            {others && others.length > 0 && others.map((g) => (
                <div key={g.groupName} className="mt-xs font-size-body-s colour-text-grey">
                    {g.groupName} <i className='material-symbols-outlined' style={{ verticalAlign: 'middle', color: '#06467D' }}>license</i>
                </div>
            ))}
            </div>
        </React.Fragment>
    );

};